import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("puerto_rico",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92903)">
                <path
                    d="M0 4.5L23.9995 4.5L23.9995 20.5L0 20.5L0 4.5Z"
                    fill="#EE0000" />
                <path
                    d="M3.19922 7.7002L23.9988 7.7002V10.9002L7.82125 10.9002V14.1002L23.9988 14.1002V17.3002L3.19922 17.3002L3.19922 7.7002Z"
                    fill="white" />
                <path
                    d="M13.8557 12.5L0 20.5L0 4.5L13.8557 12.5Z"
                    fill="#0050F0" />
                <path
                    d="M5.47667 9.00977L3.12627 15.0137L9.28148 11.3022H1.67187L7.82867 15.0137L5.47667 9.00977Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92903">
                    <rect
                        width="23.9995"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    `),o=i("puerto_rico_rounded",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92928)">
                <rect
                    x="-0.000488281"
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-0.000488281 0.5L23.999 0.5L23.999 24.5L-0.000488281 24.5L-0.000488281 0.5Z"
                    fill="#EE0000" />
                <path
                    d="M3.20264 5.2998L24.0022 5.2998V10.0998L7.82467 10.0998V14.8998L24.0022 14.8998V19.6998L3.20264 19.6998L3.20264 5.2998Z"
                    fill="white" />
                <path
                    d="M13.8552 12.5L-0.000488281 24.5L-0.000488281 0.5L13.8552 12.5Z"
                    fill="#0050F0" />
                <path
                    d="M5.47619 8.5L3.12579 15.7368L9.28099 11.2632L1.67139 11.2632L7.82819 15.7368L5.47619 8.5Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92928">
                    <rect
                        x="-0.000488281"
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as PuertoRico,o as PuertoRicoRounded};
